/**
 * File will hold application configurations.
 */

export default {
  SERVICE_API_URL: '/api/v1/nrsservice/',
  BRANDING_SERVICE_API_URL: '/api/v1/branding/',
  SYSTEM_MESSAGE: {
      LIFE_SPAN: 3000
  },
  API_GATEWAY_URL: '/api/'
};
